import classNames from "classnames";

import { BoldText } from "components/BoldText/BoldText";
import { BaseLayout } from "components/BaseLayout/BaseLayout";

import styles from "./styles.module.scss";
import { PrintTemplatesGroupList } from "./components";

const Header = (): JSX.Element => <BoldText>Типы документов</BoldText>;

export const PrintTemplatesGroup = (): JSX.Element => {
  return (
    <BaseLayout
      className={classNames("ml-2 mt-3 mb-3", styles.container)}
      header={<Header />}
      footer={<></>}
    >
      <PrintTemplatesGroupList />
    </BaseLayout>
  );
};
